import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import {
    LoadingBar,
    UITable,
    PrimaryButton,
    ChipSelect,
    ChipRangeInput,
} from '../../../components/Common';
import { createYearValues } from '../../../utils';
import { assetTypeOptions, assetStatusOptions, columns } from '../utils';
import Routes from '../../../routes';

const ValidateLeakInspections = ({
    pageTitle
}) => {
    const [loading, setLoading] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [data, setData] = useState([]);
    const [year, setYear] = useState({ id: new Date().getFullYear(), label: `${new Date().getFullYear()}`});
    const [instanceAssociation, setInstanceAssociation] = useState({ id: "", label: "" });
    const [assetType, setAssetType] = useState({ id: "", label: "" });
    const [assetStatus, setAssetStatus] = useState({ id: "", label: "" });
    const [systemCapacityMinRange, setSystemCapacityMinRange] = useState("");
    const [systemCapacityMaxRange, setSystemCapacityMaxRange] = useState("");
    const [systemLeakRateMinRange, setSystemLeakRateMinRange] = useState("");
    const [systemLeakRateMaxRange, setSystemLeakRateMaxRange] = useState("");
    const [instanceAssociationOptions, setInstanceAssociationOptions] = useState([]);
    const yearValues = createYearValues();

    const fetchData = async () => {
        const getInstanceAssociationIds = async () => {
            const data = await fetch(
                Routes.Instance.GetUserInstanceAssociations()
            );
            const instanceAssociations = await data.json();
            return instanceAssociations;
        };

        await Promise.all([
            getInstanceAssociationIds(),
            getReportData()
        ]).then(async ([instanceAssociations]) => {
            console.log('instanceAssociations', instanceAssociations);
            setInstanceAssociationOptions(instanceAssociations);
        })
        .finally(() => setReportLoading(false));

        setLoading(false);
    };

    const getReportData = async () => {
        setData([]);
        setReportLoading(true);
        setButtonDisabled(true);
        const reportParams = {
            year: year.id,
            associationId: instanceAssociation.id,
            assetTypeId: assetType.id,
            assetStatusId: assetStatus.id,
            minCapacity: systemCapacityMinRange,
            maxCapacity: systemCapacityMaxRange,
            minLeakRate: systemLeakRateMinRange,
            maxLeakRate: systemLeakRateMaxRange,
        };
        const data = await fetch(
            Routes.Reports.ValidateLeakInspections(),
            {
                method : "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(reportParams)
            }
        );
        const reportData = await data.json();
        setData(reportData);
        return setReportLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {
        return <LoadingBar />;
    }

    return (
    <>
         <Grid container sx={{ width: '100%' }}>
                <Grid item xs={6} md={6} lg={6}>
                    {pageTitle}
                </Grid>
                <Grid item xs={6} md={6} lg={6} sx={{ marginLeft: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
                    <PrimaryButton
                        disabled={buttonDisabled}
                        buttonText="Generate Report"
                        onClick={getReportData}
                    /> 
                </Grid>
        </Grid>
        <Grid
            container
            spacing={2}
            sx={{ marginTop: '1%' }}
        >
            <Grid item>
                <ChipSelect
                    label="Year"
                    disabled={reportLoading}
                    item={year}
                    onChange={(year) => {
                        setButtonDisabled(false);
                        setYear(year);
                    }}
                    options={yearValues}
                />
            </Grid>
            <Grid item>
                <ChipSelect
                    deletable
                    label="Region/Association"
                    disabled={reportLoading}
                    item={instanceAssociation}
                    onChange={(instance) => {
                        setButtonDisabled(false);
                        setInstanceAssociation(instance);
                    }}
                    options={instanceAssociationOptions}
                />
            </Grid>
            <Grid item>
                <ChipSelect
                    deletable
                    label="Asset Type"
                    disabled={reportLoading}
                    item={assetType}
                    onChange={(instance) => {
                        setButtonDisabled(false);
                        setAssetType(instance);
                    }}
                    options={assetTypeOptions}
                />
            </Grid>
            <Grid item>
                <ChipSelect
                    deletable
                    label="Asset Status"
                    disabled={reportLoading}
                    item={assetStatus}
                    onChange={(instance) => {
                        setButtonDisabled(false);
                        setAssetStatus(instance);
                    }}
                    options={assetStatusOptions}
                />
            </Grid>
            <Grid item>
                <ChipRangeInput
                    deletable
                    label="System Capacity (lbs.)"
                    abbreviation="lbs."
                    disabled={reportLoading}
                    minRangeValue={systemCapacityMinRange}
                    maxRangeValue={systemCapacityMaxRange}
                    minRangeOnChange={(new_min) => {
                        setButtonDisabled(false);
                        setSystemCapacityMinRange(new_min);
                    }}
                    maxRangeOnChange={(new_max) => {
                        setButtonDisabled(false);
                        setSystemCapacityMaxRange(new_max);
                    }}
                    minRangeHelperText="Min Capacity"
                    maxRangeHelperText="Max Capacity"
                />
            </Grid>
            <Grid item>
                <ChipRangeInput
                    deletable
                    label="System EPA Leak Rate (%)"
                    abbreviation="%"
                    disabled={reportLoading}
                    minRangeValue={systemLeakRateMinRange}
                    maxRangeValue={systemLeakRateMaxRange}
                    minRangeOnChange={(new_min) => {
                        setButtonDisabled(false);
                        setSystemLeakRateMinRange(new_min);
                    }}
                    maxRangeOnChange={(new_max) => {
                        setButtonDisabled(false);
                        setSystemLeakRateMaxRange(new_max);
                    }}
                    minRangeHelperText="Min Leak Rate"
                    maxRangeHelperText="Max Leak Rate"
                />
            </Grid>
            <Grid item xs={12}>
                {reportLoading ? (
                    <LoadingBar paddingTop={10} />
                ) : (
                    <UITable
                        data={data}
                        columns={columns}
                        url="ValidateLeakInspections"
                        noResultText="No results to display. Please use the filters about to generate your report."
                    />
                )}
            </Grid>
        </Grid>
    </>
    );
};

export default withRouter(ValidateLeakInspections);
